import React from "react";
import { Routes, Route } from "react-router-dom";
import ChangePassword from "../Components/ChangePassword/ChangePasword";

const changePassword = () => {
  return (
    <Routes>
      <Route path="/changePassword" element={<ChangePassword/>}></Route>
    </Routes>
  );
};

export default changePassword;
